import React, { Component } from 'react'
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import './List.css';
import matchSorter from 'match-sorter';
import Translate from 'translate-components';
import { reactTranslateChangeLanguage } from 'translate-components';
import CloseModal from '../../../Assets/Images/close-filters.svg';

class SubComponentTable extends Component {

  constructor(props) {
    super(props);

    this.state = {
      rowData: [],

      openedImg:
        false,
    };
    this.getRowData = this.getRowData.bind(this);
    this.setLangEn = this.setLangEn.bind(this);
  }

  setLangEn() {
    reactTranslateChangeLanguage('en');
  }


  getRowData() {
    const userToken = localStorage.getItem('userToken');
    const rowData = [];
    fetch(`${process.env.REACT_APP_API_HOST}webportal/service_request/details/${this.props.row.original.service_id}`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-AUTH-TOKEN': userToken
      },
    }).then(response => response.json())
      .then(response => {
        rowData.push(response);
        this.setState({ rowData: rowData });
      });
  }

  componentDidMount(event) {
    this.getRowData();
  }



  render() {
    const { rowData } = this.state;
    return (
      <ReactTable


        data={rowData}
        columns={[
          {
            Header: <Translate>Opis</Translate>,
            accessor: 'details:[]',
            maxWidth: 200,
            Cell: row => (
              <div>
                {
                  row.original.details && row.original.details.map((row) => {
                    if (localStorage.getItem('selectedLang') === 'en') {
                      this.setLangEn();
                    }
                    return <div key={row.item}>{row.item}</div>
                  })
                }
              </div>
            )
          },
          {
            Header: <Translate>Količina</Translate>,
            accessor: 'details',
            maxWidth: 250,
            filterMethod: (filter, row) =>
              matchSorter(row, filter.value, { keys: ["item"] }),
            Cell: row => (
              <div>
                {
                  row.original.details && row.original.details.map((row) => {
                    return <div key={row.item}>{row.item_qty}</div>
                  })
                }
              </div>
            )
          },
          {
            Header: <Translate>Slike pre intervencije</Translate>,
            accessor: 'images:[]',
            maxWidth: 620,

            Cell: (row) => {

              return row.original.images && row.original.images.before && row.original.images.before.map((item, index) => {
                return <div className="currentelement" key={index}>
                  <img style={{ display: "none" }} className="subcomponent-img" src={item} alt="state before request" />
                  <div className="content">
                    <div className="buttons">
                      <img className="button" width="150" height="auto" alt="" src={item}
                        onClick={(event) => {
                          if (event.target.classList.contains('button')) {
                            let el = event.target;
                            setTimeout(() => {
                              let parent = el.closest('.currentelement')
                              if (parent.childNodes[2].classList.contains('modal-container')) {
                                parent.childNodes[2].classList.add('one');
                                parent.childNodes[2].classList.remove('out')
                              }
                            }, 0);
                          }
                          document.querySelector('body').classList.add('modal-active');
                          let appbar = document.getElementsByClassName('appbar-title')[0];
                          appbar.style.zIndex = "0";
                        }}
                      />
                    </div>
                  </div>
                  <div className="modal-container"
                    onClick={(event) => {
                      document.querySelector('body').classList.remove('modal-active');
                    }}
                  >
                    <div className="modal-background">
                      <div className="modal">
                        <img src={CloseModal} alt=""
                          className="modal-close-btn"
                          onClick={(event) => {
                            let el = event.target;
                            let parent = el.closest('.currentelement');
                            parent.childNodes[2].classList.add('out');
                            document.querySelector('body').classList.remove('modal-active');
                            let appbar = document.getElementsByClassName('appbar-title')[0];
                            appbar.style.zIndex = "1003";
                          }}></img>
                        <img className="modal-image" src={item} alt={""} />
                      </div>
                    </div>
                  </div>
                </div>
              })
            },
          },
          {
            Header: <Translate>Slike posle intervencije</Translate>,
            accessor: 'images:[]',
            maxWidth: 620,
            Cell: (row) => {
              return row.original.images && row.original.images.after && row.original.images.after.map((item, index) => {
                return <div className="currentelementtwo"
                  key={index}> <img style={{ display: "none" }} src={item} alt="state before request" className="subcomponent-img" />
                  <div className="content">
                    <div className="buttons">
                      <img id="one" className="button" width="150" height="auto" alt="" src={item}
                        onClick={(event) => {
                          if (event.target.classList.contains('button')) {
                            let el = event.target;
                            setTimeout(() => {
                              let parent = el.closest('.currentelementtwo')
                              if (parent.childNodes[3].classList.contains('modal-container-after')) {
                                console.log(parent.childNodes[3]);
                                parent.childNodes[3].classList.add('two');
                                parent.childNodes[3].classList.remove('out')
                                let appbar = document.getElementsByClassName('appbar-title')[0];
                                appbar.style.zIndex = "0";

                              }
                            }, 0);
                            {/* AppBar.css */}
                      document.querySelector('body').classList.add('modal-active');
                    }
                  }}
                />
                    </div>
                  </div>
                  <div className="modal-container-after"
                    onClick={() => {
                      document.querySelector('body').classList.remove('modal-active');
                    }}
                  >
                    <div className="modal-background">
                      <div className="modal">
                        <img src={CloseModal} alt=""
                          className="modal-close-btn"
                          onClick={(event) => {
                            let el = event.target;
                            let parent = el.closest('.currentelementtwo');
                            parent.childNodes[3].classList.add('out');
                            document.querySelector('body').classList.remove('modal-active');
                            let appbar = document.getElementsByClassName('appbar-title')[0];
                            appbar.style.zIndex = "1003";
                          }}></img>
                        <img className="modal-image" src={item} alt={""} />
                      </div>
                    </div>
                  </div>
                </div>
              })
            },
          },
        ]}
        defaultPageSize={1}
        showPagination={false}
        show={true}
      />
    );
  }
}

export default SubComponentTable;



// WEBPACK FOOTER //
// ./src/Components/Requests/List/SubComponentTable.jsx